/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { FinancialYearData, FinancialYearView } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getFinancialYear = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<FinancialYearView | null>> => {
    return axios.get(`/api/financial-year`, options);
};

export const getGetFinancialYearQueryKey = () => {
    return [`/api/financial-year`] as const;
};

export const getGetFinancialYearQueryOptions = <
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getFinancialYear>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetFinancialYearQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getFinancialYear>>
    > = ({ signal }) => getFinancialYear({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getFinancialYear>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFinancialYearQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFinancialYear>>
>;
export type GetFinancialYearQueryError = AxiosError<unknown>;

export function useGetFinancialYear<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFinancialYear>>,
                    TError,
                    Awaited<ReturnType<typeof getFinancialYear>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFinancialYear<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getFinancialYear>>,
                    TError,
                    Awaited<ReturnType<typeof getFinancialYear>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFinancialYear<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFinancialYear<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetFinancialYearQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetFinancialYearSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getFinancialYear>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetFinancialYearQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getFinancialYear>>
    > = ({ signal }) => getFinancialYear({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getFinancialYear>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFinancialYearSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getFinancialYear>>
>;
export type GetFinancialYearSuspenseQueryError = AxiosError<unknown>;

export function useGetFinancialYearSuspense<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFinancialYearSuspense<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFinancialYearSuspense<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetFinancialYearSuspense<
    TData = Awaited<ReturnType<typeof getFinancialYear>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getFinancialYear>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetFinancialYearSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const putFinancialYear = (
    financialYearData: FinancialYearData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<FinancialYearView>> => {
    return axios.put(`/api/financial-year`, financialYearData, options);
};

export const getPutFinancialYearMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putFinancialYear>>,
        TError,
        { data: FinancialYearData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putFinancialYear>>,
    TError,
    { data: FinancialYearData },
    TContext
> => {
    const mutationKey = ["putFinancialYear"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putFinancialYear>>,
        { data: FinancialYearData }
    > = (props) => {
        const { data } = props ?? {};

        return putFinancialYear(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutFinancialYearMutationResult = NonNullable<
    Awaited<ReturnType<typeof putFinancialYear>>
>;
export type PutFinancialYearMutationBody = FinancialYearData;
export type PutFinancialYearMutationError = AxiosError<unknown>;

export const usePutFinancialYear = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putFinancialYear>>,
            TError,
            { data: FinancialYearData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof putFinancialYear>>,
    TError,
    { data: FinancialYearData },
    TContext
> => {
    return useMutation(
        getPutFinancialYearMutationOptions(options),
        queryClient
    );
};
export const postFinancialYear = (
    financialYearData: FinancialYearData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<FinancialYearView>> => {
    return axios.post(`/api/financial-year`, financialYearData, options);
};

export const getPostFinancialYearMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postFinancialYear>>,
        TError,
        { data: FinancialYearData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postFinancialYear>>,
    TError,
    { data: FinancialYearData },
    TContext
> => {
    const mutationKey = ["postFinancialYear"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postFinancialYear>>,
        { data: FinancialYearData }
    > = (props) => {
        const { data } = props ?? {};

        return postFinancialYear(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostFinancialYearMutationResult = NonNullable<
    Awaited<ReturnType<typeof postFinancialYear>>
>;
export type PostFinancialYearMutationBody = FinancialYearData;
export type PostFinancialYearMutationError = AxiosError<unknown>;

export const usePostFinancialYear = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postFinancialYear>>,
            TError,
            { data: FinancialYearData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postFinancialYear>>,
    TError,
    { data: FinancialYearData },
    TContext
> => {
    return useMutation(
        getPostFinancialYearMutationOptions(options),
        queryClient
    );
};
export const deleteFinancialYear = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/financial-year`, options);
};

export const getDeleteFinancialYearMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteFinancialYear>>,
        TError,
        void,
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteFinancialYear>>,
    TError,
    void,
    TContext
> => {
    const mutationKey = ["deleteFinancialYear"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteFinancialYear>>,
        void
    > = () => {
        return deleteFinancialYear(axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteFinancialYearMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteFinancialYear>>
>;

export type DeleteFinancialYearMutationError = AxiosError<unknown>;

export const useDeleteFinancialYear = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteFinancialYear>>,
            TError,
            void,
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteFinancialYear>>,
    TError,
    void,
    TContext
> => {
    return useMutation(
        getDeleteFinancialYearMutationOptions(options),
        queryClient
    );
};
